module.exports = __webpack_public_path__ + "img/7_cover2.3a52345b.png";